import { Gear } from "@rsuite/icons";
import { SyntheticEvent } from "react";
import { Nav, Sidenav } from "rsuite";
import { MenuInterface } from "../../../core/types/menuInterface";
export function TopRightMenu({ menu, onSelect }: { menu: any; onSelect: any }) {
  const CustomTitle = () => (
    <span className="set-title mb-hide">Settings</span>
  );
  return (
    <Nav.Menu
      eventKey="3"
      placement="bottomEnd"
      trigger="hover"
      title={<CustomTitle />}
      icon={<Gear />}
    >
      {menu.map((child: any) => {
        return (
          <Nav.Item
            key={child.menu_label}
            onSelect={(
              eventKey: string | undefined,
              event: SyntheticEvent<Element, Event>
            ) => {
              onSelect(eventKey, child.page_type);
            }}
            eventKey={child.menu_url}
          >
            {child.menu_label}
          </Nav.Item>
        );
      })}
    </Nav.Menu>
  );
}
